import { Injectable } from '@angular/core';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import {
  TeamMemberActionTypes,
  TeamMembersPageCancelled,
  TeamMembersPageLoaded,
  TeamMembersPageRequested,
  TeamMembersPageToggleLoading,
  ThrowTeamMemberError,
} from '../_actions/team-members.actions';
import { Router } from '@angular/router';
import { TeamMemberService } from '../_services/team-members.service';
import { QueryParamsModel } from '../../_base/crud';

@Injectable()
export class TeamMemberEffects {
  @Effect()
  loadTeamMembersPage$ = this.actions$.pipe(
    ofType<TeamMembersPageRequested>(TeamMemberActionTypes.TeamMembersPageRequested),
    mergeMap(({ payload }) => {
      this.store.dispatch(new TeamMembersPageToggleLoading({ isLoading: true }));
      const requestToServer = this.teamMember.findTeamMembers(payload.page, payload.category_id);
      const lastQuery = of(payload.page);
      return forkJoin([requestToServer, lastQuery]).pipe(
        catchError((error) => {
          return of([error]);
        }),
        map((response) => {
          if (response[0].error) {
            if (response[0].status === 401) {
              return response[0];
            } else if (response[0].status === 403) {
              this.router.navigateByUrl('/error/403');
              return new TeamMembersPageCancelled();
            } else {
              this.store.dispatch(new ThrowTeamMemberError({ error: response[0].error }));
              return new TeamMembersPageCancelled();
            }
          } else {
            const result = response[0];
            // tslint:disable-next-line:no-shadowed-variable
            const lastQuery: QueryParamsModel = response[1];
            return new TeamMembersPageLoaded({
              teamMembers: result.data,
              totalCount: result.count,
              page: lastQuery,
            });
          }
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private teamMember: TeamMemberService,
    private store: Store<AppState>,
    private router: Router,
  ) {}
}
